export default __webpack_public_path__ + "static/media/haeuser_intro_web-md@1x.62b41d1c.webp";